/**
 * @CustomProgress
 * enables customizable progress bar
 * add your own HTML
 * this extension only adds necessary listeners
 */
export function CustomProgress(Splide, Components, options) {
    function mount() {
        const slides = Splide.Components.Slides.get();
        const slidesAmount = Splide.Components.Slides.getLength();
        const animationInterval = Splide.options.interval;

        if (!options.customProgress || slidesAmount < 2) {
            return;
        }

        const slidesHTML = slides
            .map(
                (slide, index) => `
                <div class="splide-custom-progress-item" data-index="${index}">
                    <span class="splide-custom-progress-item-text">${index > 8 ? index + 1 : `0${index + 1}`}</span>
                </div>
            `
            )
            .join('');

        const progressHTML = `
        <div class="js-splide-custom-progress splide-custom-progress">
            <style>
                .splide-custom-progress {
                    --progress-interval: ${animationInterval}ms;
                }
            </style>
            ${slidesHTML}
        </div>
    `;

        Splide.root.insertAdjacentHTML('beforeend', progressHTML);

        Splide.on('active', () => {
            const progressItems = [...Splide.root.querySelectorAll('.splide-custom-progress-item')];

            progressItems.forEach((item) => {
                item.classList.remove('is-active');
            });

            const activeItem = progressItems.find(
                (item) => item.dataset.index === Splide.index.toString()
            );

            if (activeItem) {
                activeItem.classList.add('is-active');
            }
        });
    }

    return { mount };
}
